<div class="header">
  <!-- to do: move the title to a component used here and in kpi-comment with https://quantive-inc.atlassian.net/browse/GVS-46476 -->
  <h5>
    <formatted-value [value]="commentData.targetValue" [formatting]="kpi.formatting" [maximumFractionDigits]="5" maxFormattingUnitWidth="100px"></formatted-value>
    <i
      class="text-color-warning-10"
      *ngIf="showInfoIcon"
      [uiTooltipTitle]="'your_comment_will_move_with_the_data_point_if_it_changes_before_the_end_of_the_date' | localize"
      ui-icon
      ui-tooltip
      uiType="attention"
      uiTheme="outline"></i>
    <div class="date">{{ commentData.targetDate | date : "dd MMM, YYYY" }}</div>
  </h5>
  <div class="actions">
    <button (click)="onCancel()" ui-modal-close></button>
  </div>
</div>
<div class="body">
  <comments
    #comments
    [skipFetchingComments]="true"
    [externalActionButtons]="comments.comments?.length === 0"
    [initialMentions]="kpi.ownerIds"
    [target]="{ id: kpi.id, type: commentData.targetType, date: commentData.targetDate, title: kpi.name }"
    [inputPlaceholder]="'your_comment_placeholder' | localize"
    [metadata]="metadata"
    (add)="onCommentCreated($event)"
    (cancel)="onCancel()"></comments>
</div>
